import { RESET_PROGRESS_INDICATOR_LIST } from "./types";
import { checkNestedObject } from "utils/checkNestedObject";

export const resetProgressIndicatorList = () => (dispatch, getState) => {
  const { pageContent } = getState();

  if (checkNestedObject(pageContent, "navigation_items") && pageContent.navigation_items.length) {
    dispatch({ type: RESET_PROGRESS_INDICATOR_LIST });
  }
};
